<template>
  <article class="trainers pt-5">
    <section class="trainers__header_sublocation section_first_child">
      <div class="trainers__header_sublocation--back">
        <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/icono-volver.svg" alt=""
           @click="$router.push({name: 'location_access', params: {id: parmsLocationId }})">
        <p @click="$router.push({name: 'location_access', params: {id: parmsLocationId }})">Volver a Sede {{ parmsLocationName }}</p>
      </div>
      <div class="trainers__header_sublocation--today">
        <div v-if="location_time_zone !== timeZoneLocal" class="trainers__header_sublocation--time_zone">
          <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/watch.svg" alt="">
          <p>Zona horiaria de {{ time_zone }}, {{ country }} (GTM{{ gtm }})</p>
        </div>
        <v-hover>
          <div
            @click="findBookings()"
            slot-scope="{ hover }"
            class="accessIndex__reload--container"
            :class="hover?'accessIndex__interaction--hover':''">
            <img src="@/assets/img/icons/refresh-icon.svg" alt="">
          </div>
        </v-hover>
        <div class="trainers__header_sublocation--current_day">{{ day_name }}</div>
        <app-single-date-picker
          v-show="false"
         :date_text="day_today !== '' ? day_today : today()"
         @filterQuery="filterQuery"
        >
        </app-single-date-picker>
      </div>
    </section>
    <section class="trainers__header_sublocation">
      <div>
        <div class="trainers__header_sublocation--content_title">
          <h1>{{ paramsSublocationName }}</h1>
        </div>
<!--         <div class="trainers__header_sublocation--div_quotas">
          <p>CUPOS DISPONIBLES</p>
          <span>{{ max_spaces - get_spaces }}</span>
        </div> -->
      </div>
      <div>
        <div class="trainers__header_sublocation--buttons" v-if="!invitations">
          <div v-if="(tags[0].number + tags[2].number) < paramsMaxSpaces"  class="type_buttom type_buttom__blue">
            CUPOS LIBRES
          </div>
          <div v-else class="type_buttom type_buttom__green">
            CUPO LLENO
            <span v-if="tags[0].number>0">{{ tags[0].number }}</span>
          </div>
        </div>
        <div class="trainers__header_sublocation--user_inside">
          <p v-if="!invitations">Usuarios adentro</p>
          <p v-else>Invitados adentro</p>
        </div>
        <div class="trainers__header_sublocation--count_total" v-if="!invitations">
          <div>
            <p>PERSONAS</p>
            <p></p>
            <p>CUPOS</p>
          </div>
          <div>
            <span>{{ tags[0].number + tags[2].number }}</span>
            <span>/</span>
            <span>{{ paramsMaxSpaces }}</span>
          </div>
        </div>
        <div class="trainers__header_sublocation--count_total" v-else>
          <div>
            <span>{{ tags[0].number + tags[2].number }}</span>
          </div>
        </div>
      </div>
    </section>
    <hr class="trainers__line">
    <v-flex
      xs12
      style="display:flex; margin: 50px 3% 0px 3%; justify-content: flex-start;">
        <v-layout
            class="data_card__headers--title_reservation"
            row wrap justify-space-between>
          <v-flex  v-for="tag in tags"
            :key="tag.name"
            class='data_card__headers--days_reservation'
            :class="tag.id===current_tag? 'data_card__headers--days_reservation_active':'data_card__headers--days_reservation'"
            @click="tagSelect(tag.id)"
            :style="tag.id!=current_tag?'color:rgb(152,152,152);':tag.id==1?'color:#E84335':''">
            <div :class="tag.id===1 && current_tag===1?
                         tag.id===1 && current_tag===1? 'data_card__info--label_reservation_active': '' :
                         tag.id===current_tag && current_tag!==1? 'data_card__info--label_reservation_black' : ''
                        ">
              <p>{{ tag.name_one }}
              <br>{{ tag.name_two }}</p>
            </div>
            <div :class="tag.id===current_tag? 'data_card__info--label_number_active':'data_card__info--label_number'">
              <img v-if="tag.id===1 && current_tag===1" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/icono-importante+(1).svg" alt="">
              <span>
                {{ tag.number }}
              </span>
            </div>
          </v-flex>
        </v-layout>
    </v-flex>
    <v-flex
      xs12
      style="display:flex; margin: 0px 3% 0px 3%;">
        <v-layout
            row wrap justify-space-between>
          <v-flex  v-for="tag in tags"
            :key="tag.name"
            class="data_card__headers--days--transparency_reservation"
            :style="tag.id===current_tag?
                      tag.id===current_tag?'margin-top:-12px !important;background:#FFF':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
                      tag.id!==current_tag?'': 'cursor:not-allowed;'"
            @click="tagSelect(tag.id)">
          </v-flex>
        </v-layout>
    </v-flex>

    <section class="trainers__create_container data_card__headers--days--panel" >
      <v-layout row wrap>
        <v-flex xs12>
          <v-flex
            xs12 >
            <v-layout row wrap style="justify-content:space-evenly">
              <v-flex xs4>
                <span class="data_card__info--label_title">Nombres y apellidos
                  <div>
                    <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/icono-ordenar.svg" alt="">
                  </div>
                </span>
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label_title">RUT</span>
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label_title">Fecha</span>
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label_title">Hora de ingreso</span>
              </v-flex>
              <v-flex xs2>
                <span class="data_card__info--label_title">Hora de Salida</span>
              </v-flex>
            </v-layout>
            <hr>
            <v-layout row wrap style="justify-content:space-evenly"
              v-for="(user,index_user) in users_tag"
              :key="index_user">
                <v-flex xs4>
                  <span class="data_card__info--label_content_left">{{ user.name }}</span>
                </v-flex>
                <v-flex xs2>
                  <span class="data_card__info--label_content">{{ user.rut }}</span>
                </v-flex>
                <v-flex xs2>
                  <span class="data_card__info--label_content">{{ user.date }}</span>
                </v-flex>
                <v-flex xs2>
                  <span class="data_card__info--label_content">{{ formatAMPM(user.start_time) }}</span>
                </v-flex>
                <v-flex xs2>
                  <span class="data_card__info--label_content">{{ formatAMPM(user.end_time) }}</span>
                </v-flex>
              <hr>
            </v-layout>
            <v-layout
                row wrap style="justify-content:space-evenly">
                <v-flex xs12>
                  <div class="data_card__page">
                   <!--  <div>
                      Paginas
                    </div>
                    <div v-for="(page,index) in total_pages" :key="index"
                        @click="clickPages(page)">
                        {{ page }}
                    </div> -->
                    <ads-pagination
                      class="pagination"
                      @current_page="pageChange"
                      :page="page"
                      :maxVisiblePages="max_visible_page"
                      :itemsPerPage="items_per_page"
                      :totalItems="totalItems()">
                    </ads-pagination>
                  </div>
                </v-flex>
              <hr>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </section>
  </article>
</template>

<script>


export default {
  data(){
    return{
      sublocations:[],
      sublocation_selected: null,
      location_name: '',
      max_spaces: '',
      get_spaces: '',
      day_today: '',
      day_name: '',
      day_name_english: '',
      current_tag: '',
      total_population: '',
      users_tag: [],
 /*      pages: [], */
      total_pages: [],
      page_select: null,
      time_zone: '',
      tags: [{ id: 1, name_one: "Usuarios con tiempo",      name_two: "máximo excedido", number: 0 , page: 1},
             { id: 2, name_one: "Usuarios con reservacion", name_two: "sin ingreso",      number: 0 , page: 1},
             { id: 3, name_one: "Usuarios con reservacion", name_two: "a tiempo",         number: 0 , page: 1}
      ],
      current_reservation: [],
      myRequestInterval:null,
      loading: false,
      page: 1,
      items_per_page: 20,
      max_visible_page: 5,
      country: '',
      gtm: '',
      location_time_zone: '',
      invitations: false,
    }
  },
  components: {
  },
  computed:{
  /*   lastView(){
      if(this.$route.path.includes("locations")){
        return "locations"
      }
      return "access"
    }, */
    parmsLocationId: function() {
      return this.$route.params.location_id;
    },
    parmsLocationName: function() {
      return this.$route.params.location_name;
    },
    paramsSublocationId: function() {
      return this.$route.params.id;
    },
    paramsSublocationName: function() {
      return this.$route.params.sublocation_name;
    },
    paramsMaxSpaces: function() {
      return this.$route.params.max_spaces;
    },
    timeZoneLocal: function(){
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
      return resolvedOptions.timeZone
    }
  },
  methods:{
    findBookings(){
      var params = this.$route.params;
      try {
        this.$http.get('app/bookings/current_population',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            sublocation_id: params.id,
            current_datetime: this.current_datetime(),
            day: this.day_name_english,
            page_not_entered:  this.current_tag === 1 ? this.page : null,
            page_not_comet_out: this.current_tag === 2 ? this.page : null,
            page_current_population: this.current_tag === 3 ? this.page : null,
            location_id: params.location_id,
            invitations: this.invitations
          }
        })
        .then(function(response){
          this.current_reservation = response.body.get_population;
          this.location_time_zone = response.body.time_zone
          this.time_zone=response.body.time_zone.substring(response.body.time_zone.indexOf('/') + 1,response.body.time_zone.length).replace(/[_]/g,' ')
          this.country=response.body.country
          this.gtm=response.body.gtm.replace(/[0]/g,'')
          for(let i = 0;i < this.tags.length;i++ ){
            this.tags[i].number = this.current_reservation[i].quantity
          }
          this.tagSelect(this.current_tag);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.loading = true;
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    clickPages: function(){
      this.findBookings();
      this.mapUserTags();
    },
    currentToday: function(d_parms){
      let weekday = new Array(7);
      weekday[0] = "DOMINGO";
      weekday[1] = "LUNES";
      weekday[2] = "MARTES";
      weekday[3] = "MIERCOLES";
      weekday[4] = "JUEVES";
      weekday[5] = "VIERNES";
      weekday[6] = "SABADO";
      let n = weekday[d_parms];
      let date =  new Date();
      let dd = this.changeFormatDate(this.day_today);
      if (date.getDate() === dd.getDate() && date.getMonth() === dd.getMonth() && date.getFullYear() === dd.getFullYear()){
        n = 'HOY'
      }
      /* this.changeFormatDate(); */
      this.day_name = n;
      return n;
    },
    currentTodayEnglish: function(day){
      let weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      let n = weekday[day];
      this.day_name_english = n;
      return n;
    },
    filterQuery: function(date){
      this.day_today = date;
      let day = this.changeFormatDate(date);
      this.currentToday(day.getDay());
      this.currentTodayEnglish(day.getDay());
      this.findSublocations();
    },
    changeFormatDate(date) {
      /* 29/05/2020 to 2020-05-29 */
      let new_date = '';
      new_date = date.substring(6,10) + '-' + date.substring(3,5) + '-' + date.substring(0,2) + 'T00:00:00';
      new_date = new Date(Date.parse(new_date));
      return new_date
    },
    today: function() {
      let date =  new Date();
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
          dd = '0' + dd;
      }
        if (mm < 10) {
          mm = '0' + mm;
      }
      let date_complete = dd + '/' + mm + '/' + yyyy;
      this.day_today = date_complete;
      this.currentToday(date.getDay());
      this.currentTodayEnglish(date.getDay());
      return date_complete;
    },
     current_datetime: function(){
      let date = new Date().toISOString();
      /* let dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " +
        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2) + ":" +
        ("00" + date.getSeconds()).slice(-2);
        return dateStr */
        return date.replace(/[ZT]/g,' ')
    },
    tagSelect: function(tag_id){
      this.page = 1,
      this.current_tag=tag_id;
      this.mapUserTags();
    },
    mapUserTags: function(){
      this.users_tag = []
      this.pages = []
      this.total_pages = []
      if (this.current_reservation.length > 0) {
        this.users_tag = this.current_reservation.find(e => e.id === this.current_tag).users
        this.page = this.current_reservation.find(e => e.id === this.current_tag).pages
        for(let i = 1;i<=this.pages; i++){
          this.total_pages.push(i)
        }
        /* for(let i) */
      }

    },
    formatAMPM: function(date_old) {
      /* .replace(/[Zz]/g,'') */
     /*  let date = new Date (Date.parse(String(date_old)))
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime; */
      if (this.loading === true) {
        let s_date= new Date(date_old).toLocaleString('en-GB', { timeZone: this.location_time_zone })
        let hour=s_date.split(",")[1]
        let realHour= hour.split(":")
        let start=this.convertHourToStyleFormat(realHour[0]+":"+ realHour[1])
        return start
      }
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
        amOrPm="pm"
        if(arr[0]>12){
          arr[0]= Number(arr[0])%12
        }
      }else if(arr[0]==0){
        arr[0]=12
      }
      if(Number(arr[0])<10){
        arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    pageChange(page) {
      this.page = page;
      this.clickPages()
    },
    rageChange(start, end) {
      this.start = start;
      this.end = end;
    },
    totalItems(){
      let number_items = 0
      if (this.current_reservation !== '' && this.current_reservation !== null && this.current_reservation !== undefined) {
        number_items = this.current_reservation.find(e => e.id === this.current_tag)
        if (number_items !== undefined && number_items !== NaN) {
          number_items = this.current_reservation.find(e => e.id === this.current_tag).quantity
        }
      }
      number_items === NaN || number_items === undefined ? number_items = 0 : number_items
      return number_items
    }
  }, /* closed methods */
  mounted(){
    this.current_tag = 1;
    if(this.$route.params.sublocation_name === "Invitados"){
      this.invitations = true
      this.tags = [{ id: 1, name_one: "Invitados con tiempo",      name_two: "máximo excedido", number: 0 , page: 1},
             { id: 2, name_one: "Invitados con invitación", name_two: "sin ingreso",      number: 0 , page: 1},
             { id: 3, name_one: "Invitados con invitación", name_two: "a tiempo",         number: 0 , page: 1}
      ]
    }
    this.findBookings()
    var vm = this;
    this.myRequestInterval=setInterval(function(){
        /* Actualiza cada 5 minutos */
        vm.findBookings();
    },300*1000);
  },
  beforeDestroy(){
    clearInterval(this.myRequestInterval)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/Reservation.vue